import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Container } from './AboutUsGraphic.styled'
import TypographyAtom from '../../atoms/typography/typography'
import Image from '../../atoms/images/images'

function AboutUsGraphic({ desktopConsultancyImages }) {
  return (
    <Container>
      <div className="flex">
        <div className="col-xs-3 ">
          <StaticImage
            src="../../../assets/images/about-us-top-left-arrow.png"
            width={403}
            height={418}
            alt="Top Left Arrow"
          />
        </div>
        <div className="col-xs-3 graphic-item">
          <Image
            imgSrc={desktopConsultancyImages[0]?.gatsbyImageData}
            altTag={desktopConsultancyImages[0]?.description}
            hasFrame="Left Clipped"
            aspectRatio="1/1"
          />
          <TypographyAtom
            className="item-label"
            type="P"
            weight="Regular"
            copy={desktopConsultancyImages[0]?.description}
          />
        </div>
        <div className="col-xs-3">
          <StaticImage
            src="../../../assets/images/about-us-top-right-arrow.png"
            width={279}
            height={322}
            alt="Top Right Arrow"
          />
        </div>
      </div>
      <div className="flex">
        <div className="col-xs-3 graphic-item">
          <Image
            imgSrc={desktopConsultancyImages[4]?.gatsbyImageData}
            altTag={desktopConsultancyImages[4]?.description}
            hasFrame="Left Clipped"
            aspectRatio="1/1"
          />
          <TypographyAtom
            className="item-label"
            type="P"
            weight="Regular"
            copy={desktopConsultancyImages[4]?.description}
          />
        </div>
        <div className="col-xs-3">
          <StaticImage
            src="../../../assets/images/about-us-logo.png"
            width={274}
            height={108}
            alt="Heliguy logo"
          />
        </div>
        <div className="col-xs-3 graphic-item">
          <Image
            imgSrc={desktopConsultancyImages[1]?.gatsbyImageData}
            altTag={desktopConsultancyImages[1]?.description}
            hasFrame="Left Clipped"
            aspectRatio="1/1"
          />
          <TypographyAtom
            className="item-label"
            type="P"
            weight="Regular"
            copy={desktopConsultancyImages[1]?.description}
          />
        </div>
      </div>
      <div className="flex">
        <div className="col-xs-3">
          <StaticImage
            src="../../../assets/images/about-us-bottom-right-arrow.png"
            width={281}
            height={292}
            alt="Bottom Right Arrow"
          />
        </div>
        <div className="col-xs-3">
          <StaticImage
            src="../../../assets/images/about-us-bottom-right-arrow.png"
            width={281}
            height={292}
            alt="Bottom Right Arrow"
          />
        </div>
      </div>
      <div className="flex">
        <div className="col-xs-3 graphic-item">
          <Image
            imgSrc={desktopConsultancyImages[3]?.gatsbyImageData}
            altTag={desktopConsultancyImages[3]?.description}
            hasFrame="Left Clipped"
            aspectRatio="1/1"
          />
          <TypographyAtom
            className="item-label"
            type="P"
            weight="Regular"
            copy={desktopConsultancyImages[3]?.description}
          />
        </div>
        <div className="col-xs-3">
          <StaticImage
            src="../../../assets/images/about-us-bottom-arrow.png"
            width={276}
            height={217}
            alt="Bottom Arrow"
          />
        </div>
        <div className="col-xs-3 graphic-item">
          <Image
            imgSrc={desktopConsultancyImages[2]?.gatsbyImageData}
            altTag={desktopConsultancyImages[2]?.description}
            hasFrame="Left Clipped"
            aspectRatio="1/1"
          />
          <TypographyAtom
            className="item-label"
            type="P"
            weight="Regular"
            copy={desktopConsultancyImages[2]?.description}
          />
        </div>
      </div>
    </Container>
  )
}

export default AboutUsGraphic
